import api from './client';

// Points/Currency System API
export const pointsAPI = {
  // Balance
  getBalance: () => api.get('/points/balance'),
  getOrganizationBalances: () => api.get('/points/balances'),

  // Transactions
  getTransactions: (params?: {
    limit?: number;
    offset?: number;
    transactionType?: string;
    startDate?: string;
    endDate?: string;
  }) => api.get('/points/transactions', { params }),

  // Leaderboard
  getLeaderboard: (params?: { period?: 'daily' | 'weekly' | 'monthly' | 'all_time'; limit?: number }) =>
    api.get('/points/leaderboard', { params }),

  // Store
  getStoreItems: (params?: { category?: string; includeInactive?: boolean }) =>
    api.get('/points/store', { params }),
  createStoreItem: (data: {
    name: string;
    description?: string;
    category: 'privilege' | 'treat' | 'activity' | 'custom';
    pointCost: number;
    durationHours?: number;
    stockLimit?: number;
    purchaseLimitPerDay?: number;
    purchaseLimitPerWeek?: number;
    purchaseLimitTotal?: number;
    icon?: string;
    displayOrder?: number;
  }) => api.post('/points/store', data),
  updateStoreItem: (itemId: number, data: Partial<{
    name: string;
    description: string;
    category: string;
    pointCost: number;
    durationHours: number;
    stockLimit: number;
    purchaseLimitPerDay: number;
    purchaseLimitPerWeek: number;
    purchaseLimitTotal: number;
    isActive: boolean;
    icon: string;
    displayOrder: number;
  }>) => api.put(`/points/store/${itemId}`, data),
  deleteStoreItem: (itemId: number) => api.delete(`/points/store/${itemId}`),
  purchaseItem: (itemId: number) => api.post(`/points/store/${itemId}/purchase`),

  // Purchases
  getPurchases: (params?: { status?: string; limit?: number; offset?: number }) =>
    api.get('/points/purchases', { params }),
  getPendingPurchases: () => api.get('/points/purchases/pending'),
  approvePurchase: (purchaseId: number) => api.post(`/points/purchases/${purchaseId}/approve`),
  denyPurchase: (purchaseId: number, reason?: string) =>
    api.post(`/points/purchases/${purchaseId}/deny`, { reason }),
  redeemPurchase: (purchaseId: number, notes?: string) =>
    api.post(`/points/purchases/${purchaseId}/redeem`, { notes }),

  // Admin actions
  awardBonus: (userId: string | number, amount: number, description?: string) =>
    api.post('/points/bonus', { userId: userId, amount, description }),
  deductPenalty: (userId: string | number, amount: number, description?: string) =>
    api.post('/points/penalty', { userId: userId, amount, description }),

  // Batch admin actions (N+1 elimination)
  awardBonusBatch: (userIds: string[], amount: number, description: string) =>
    api.post('/points/bonus-batch', { userIds, amount, description }),
  deductPenaltyBatch: (userIds: string[], amount: number, description: string) =>
    api.post('/points/penalty-batch', { userIds, amount, description }),

  // Configuration (admin only)
  getConfig: () => api.get('/points/config'),
  updateConfig: (data: Partial<{
    pointNameSingular: string;
    pointNamePlural: string;
    pointSymbol: string;
    taskCompletionPoints: number;
    streakBonusPoints: number;
    streakMilestoneMultiplier: number;
    earlyCompletionBonus: number;
    perfectWeekBonus: number;
    dailyEarningCap: number;
    weeklyEarningCap: number;
    storeEnabled: boolean;
    requireApprovalForPurchases: boolean;
    showBalanceToUser: boolean;
    showTransactionHistory: boolean;
    failurePenaltyEnabled: boolean;
    rejectionPenaltyPoints: number;
    overduePenaltyPoints: number;
    missedDeadlinePenaltyPoints: number;
  }>) => api.put('/points/config', data),
};
